import { useState, useEffect } from 'react'

export const useNutritionManagement = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [nutritionOptions, setNutritionOptions] = useState([])

  useEffect(() => {
    fetchNutritionOptions()
  }, [])

  const fetchNutritionOptions = async () => {
    setIsLoading(true)

    try {
      // In production, this would be an API call to fetch nutritional options
      // For now, we'll use mock data
      const options = [
        { value: 'mediterranean', label: 'Mediterranean Diet' },
        { value: 'vegan', label: 'Vegan Diet' },
        { value: 'paleo', label: 'Paleo Diet' },
        { value: 'ketogenic', label: 'Ketogenic Diet' },
        { value: 'dash', label: 'DASH Diet' },
        { value: 'low-carb', label: 'Low-Carb Diet' },
        { value: 'pescatarian', label: 'Pescatarian Diet' },
        { value: 'vegetarian', label: 'Vegetarian Diet' },
        { value: 'flexitarian', label: 'Flexitarian Diet' },
        { value: 'gluten-free', label: 'Gluten-Free Diet' },
        { value: 'low-fodmap', label: 'Low FODMAP Diet' },
        { value: 'anti-inflammatory', label: 'Anti-Inflammatory Diet' },
        { value: 'mind-diet', label: 'MIND Diet' },
        { value: 'whole30', label: 'Whole30 Diet' },
        { value: 'balanced', label: 'Balanced Diet' },
        { value: 'intermittent-fasting', label: 'Intermittent Fasting' },
        { value: 'plant-based', label: 'Plant-Based Diet' },
        { value: 'calorie-controlled', label: 'Calorie-Controlled Diet' }
      ]

      setNutritionOptions(options)
    } catch (error) {
      console.error('Error fetching nutrition options', error)
    }

    setIsLoading(false)
  }

  const addCustomNutrition = (customOption) => {
    if (!customOption || !customOption.value || !customOption.label) return

    // Check if the option already exists
    const exists = nutritionOptions.some((option) => option.value === customOption.value)
    if (exists) return

    setNutritionOptions([...nutritionOptions, customOption])
  }

  return {
    isLoading,
    nutritionOptions,
    fetchNutritionOptions,
    addCustomNutrition
  }
}
